import styled, { css, keyframes } from 'styled-components'

// Utils
import { breakpoint } from 'utils'

// Types
interface DigitProps {
  $isActive: boolean
  $isDisabled?: boolean
  $hasError: boolean
}

// Animations
const blink = keyframes`
  0% { border-color: black;}
  50% { border-color: black;}
  51% { border-color: transparent;}
  100% { border-color: transparent;}
`

export const Wrapper = styled.div`
  position: relative;
`

export const HiddenInput = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
`

export const Digits = styled.div`
  display: flex;
`

export const Error = styled.p`
  padding-top: 8px;
  font-size: ${({ theme }) => theme.fontSizes.little};
  color: ${({ theme }) => theme.colors.state.negative};
`

export const Digit = styled.span<DigitProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 68px;
  height: 86px;
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: 32px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-align: center;
  background: ${({ theme, $isActive }) =>
    $isActive
      ? `${theme.colors.background.secondary[1]}`
      : `${theme.colors.background.secondary[2]}`};
  border: ${({ theme }) => `1px solid ${theme.colors.border[2]}`};
  border-radius: ${({ theme }) => theme.radii.large};
  box-shadow: inset 0px 1px 2px 0px ${({ theme }) => theme.colors.shadow.inner};
  opacity: ${({ $isDisabled }) => ($isDisabled ? `0.5` : `1`)};

  /* Transition timings and duration */
  transition: ${({ theme }) => css`
    border ${theme.transitions.duration[1]} ${theme.transitions.timing.easeInOut},
    background ${theme.transitions.duration[4]} ${theme.transitions.timing.easeInOut};
    `};

  :not(:last-child) {
    margin-right: 8px;
  }

  ${({ theme }) => breakpoint('base', 'xs')`
    height: 58px;
    font-size: ${theme.fontSizes.xlarge};

  `}

  /* Error state */
  ${({ theme, $hasError }) => {
    if ($hasError) {
      return css`
        border: 2px solid ${theme.colors.state.negative};
      `
    }
  }}

  /* Active state */
    ${({ theme, $isActive, $isDisabled }) => {
    if ($isActive && !$isDisabled) {
      return css`
        border: 2px solid ${theme.colors.primaryTint[100]};

        /* Blinking cursor */
        ::after {
          content: '';
          margin: 0;
          padding: 0;
          border-right: 1px solid black;
          animation: ${blink} 1s linear infinite;
        }
      `
    }
  }}
`
